// query + mutation ของเอกสาร
//
// ดึงทีเดียวทั้งแบรนด์ (?product=) แล้วแบ่งกลุ่มตามแคมเปญในหน้า — สลับแคมเปญไปมา
// จึงไม่ยิงใหม่ทุกครั้ง และจำนวนไฟล์ต่อแบรนด์อยู่ในระดับหลักสิบ ไม่ใช่หลักพัน
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  type DocumentArea,
  type FinanceCategory,
  deleteDocument,
  documentKeys,
  fetchDocuments,
  patchDocument,
  uploadDocument,
} from "./documents-api";

export function useDocuments(product: string | undefined, area: DocumentArea = "doc") {
  return useQuery({
    queryKey: documentKeys.byProduct(product ?? "", area),
    queryFn: () => fetchDocuments(product!, area),
    enabled: !!product,
  });
}

/** mutation ทั้งสามตัวใช้ product เดียวกันเพื่อ invalidate รายการเดิมหลังสำเร็จ */
export function useDocumentMutations(product: string, area: DocumentArea = "doc") {
  const qc = useQueryClient();
  const invalidate = () =>
    qc.invalidateQueries({ queryKey: documentKeys.byProduct(product, area) });

  const upload = useMutation({ mutationFn: uploadDocument, onSuccess: invalidate });
  const patch = useMutation({
    mutationFn: ({
      id,
      ...body
    }: {
      id: string;
      name?: string;
      preview?: boolean;
      category?: FinanceCategory;
      campaignId?: string;
    }) => patchDocument(id, body),
    onSuccess: invalidate,
  });
  const remove = useMutation({ mutationFn: deleteDocument, onSuccess: invalidate });

  return { upload, patch, remove };
}
